"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Blog = function Blog(_ref) {
  var title = _ref.title,
      description = _ref.description,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["title", "description", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "aria-hidden": !title,
    "aria-labelledby": "BlogTitle BlogDescription",
    height: height,
    preserveAspectRatio: "none",
    role: "img",
    viewBox: "0 0 24 24",
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement("title", {
    id: "BlogTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("desc", {
    id: "BlogDescription"
  }, description), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(0.75 0.75)",
    d: "M23.129 12.431a1.262 1.262 0 1 1 0-2.524 1.262 1.262 0 0 1 0 2.524zm-9.445-1.822h6.392v1.111h-6.392v-1.111zm0 5.004h10.707v1.111H13.684v-1.11zm0 5.005h10.707v1.11H13.684v-1.11zM9.062 4.284v21.503a1.6 1.6 0 1 1-3.195 0v-8.84h1.577v-1.111H4.778v9.95a2.711 2.711 0 0 0 2.706 2.712h17.81a3.111 3.111 0 0 0 3.11-3.111V4.284H9.062zm18.222 21.094a2.013 2.013 0 0 1-2.008 2.009H9.666a2.693 2.693 0 0 0 .525-1.6V5.396h17.107l-.014 19.982z",
    id: "refBlogNKLXl8oi977"
  })), /*#__PURE__*/_react["default"].createElement("use", {
    xlinkHref: "#refBlogNKLXl8oi977"
  }));
};

Blog.defaultProps = {
  description: '',
  height: 24,
  title: null,
  width: 24
};
Blog.propTypes = {
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var _default = Blog;
exports["default"] = _default;